// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".FeedbackModal-cls1__a80880ce6bc3f766c97e{/*!*/}.FeedbackModal-cls2__cd07d99b67e71ebe71a2{padding:0;border:none;background-color:inherit;cursor:pointer}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "FeedbackModal-cls1__a80880ce6bc3f766c97e",
	"cls2": "FeedbackModal-cls2__cd07d99b67e71ebe71a2 FeedbackModal-cls1__a80880ce6bc3f766c97e"
};
export default ___CSS_LOADER_EXPORT___;
